import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import { initProductOptions } from '../ProductOptionsSelector';

const selectSelectedProductLot = memoize((sourceMiniPDP) =>
    createSelector(
        [initProductOptions(sourceMiniPDP)],
        (productOptions) => productOptions.selectedProductLot
    )
);

export default selectSelectedProductLot;
